<template>
    <div>
        <!-- 登录界面 -->
        <div class="layui-container login-container">
            <div class="login-form">
                <el-form :model="form" ref="ruleForm" class="layui-form layui-form-pane1">
                    <h1>用户登录</h1>
                    <div class="layui-form-item">
                        <label class="layui-form-label">
                            <b style="color: red">*</b> 用户手机</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.username" autocomplete="off" placeholder="请输入登录手机号"></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"><b style="color: red">*</b> 登录密码</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.password" autocomplete="off" show-password placeholder="请输入登录密码"></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">
                            <b style="color: red">*</b>图形验证</label>
                        <div class="layui-input-inline">
                            <el-input v-model="form.captcha" autocomplete="off" placeholder="请输入图形验证码" style="width:156px;float: left"></el-input>
                            <img style="border-radius: 3px;float: left;margin-left: 10px;cursor: pointer;border: #cccccc 1px solid;" alt="验证码" ref="codeImg" id="codeImg" src="" width="130"
                                 height="39" @click="changeCode()"/>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"></label>
                        <div class="layui-input-inline">
                            <button class="layui-btn" type="button" @click="formSubmit();" style="float: left">
                                立即登录
                            </button>
                            <div style="float: right;margin-top: 15px;margin-right: 50px">
                                <a style="color: #5290ff; font-size: 12px;" href="javascript:void(0)" @click="handleRegister">立即注册</a>
                                <a style="color: #5290ff; font-size: 12px;margin-left: 15px" href="javascript:void(0)" @click="handleForgetPd">忘记密码</a>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                token:'',
                form: {
                    username: '',
                    password: '',
                    captcha: ''
                }
            };
        },
        methods: {
            changeCode() {
                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/getCaptcha',
                    data: {},
                    responseType: 'blob'
                }).then(res => {
                    let img = this.$refs.codeImg;
                    let url = window.URL.createObjectURL(res.data);
                    img.src = url;
                    this.token = res.headers['access-token'];
                });
            },
            formSubmit() {

                if(!this.form.username){
                    this.$notify({
                        title: '请输入手机号！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.password){
                    this.$notify({
                        title: '请输入密码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }
                if(!this.form.captcha){
                    this.$notify({
                        title: '请输入图形验证码！',
                        type: 'warning',
                        offset: 600
                    });
                    return false;
                }

                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/login',
                    data: this.form,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Token': this.token  //将token放在请求头带到后端
                    }
                }).then(res => {
                    if (res.data.code == 0) {

                        let token = res.headers['authorization'];
                        let username = res.data.data.username;

                        this.$store.commit('setToken', token);
                        this.$store.commit('setUserName', username);

                        //由于store缓存在F5刷新页面是值会丢失，故通过localStorage本地缓存一份，方便后面复制
                        localStorage.setItem("user_token", token);
                        localStorage.setItem("username", username);

                        //登录成功，跳转到首页
                        this.$emit('handleToggleTab', 1);
                    } else {
                        this.$notify({
                            title: res.data.msg,
                            type: 'error',
                            offset: 600
                        });

                        this.form.captcha = '';
                        this.changeCode();
                    }
                })
            },
            handleRegister() {
                this.$emit('handleToggleTab', 6);
            },
            handleForgetPd() {
                this.$emit('handleToggleTab', 7);
            }
        },
        created() {
            this.changeCode();
        }
    };
</script>

<style scoped>

</style>